<template>
	<div id="auth">
		<div class="form">
			<div class="row">
				<input
					id="phone-input"
					type="phone"
					v-model="phone"
					v-mask="phoneMask"
					placeholder="+7 000 000 00 00"
					@keypress.enter="sendPhone"
					:disabled="phoneSending"
					class="visible"
				/>
				<div class="confirm" @click="sendPhone" v-if="!phoneSended">
					→
				</div>
			</div>

			<div class="row">
				<input
					type="text"
					id="code-input"
					v-model="code"
					v-mask="codeMask"
					placeholder="0000"
					autocomplete="one-time-code"
					@keyup="checkCode"
					:class="{ visible: phoneSended }"
					:disabled="codeSending"
					v-focus="phoneSended"
				/>
			</div>

			<div class="row">
				<input
					type="text"
					v-model="tfa"
					placeholder="000000"
					:class="{ visible: codeSended }"
					v-focus="codeSended"
				/>
				<uiButton
					@click="sendTfa"
					v-if="codeSended"
					:loading="tfaSending"
					style="margin-top: 20px"
				>
					Поехали
				</uiButton>
			</div>
		</div>
	</div>
</template>

<script>
import Events from '@/utils/events'
import { API } from '@/config'
import VLD from '@/utils/validate'
import { focus } from 'vue-focus'

export default {
	name: 'AuthPage',
	directives: { focus },
	data() {
		return {
			phone: '',
			code: '',
			tfa: '',
			phoneSending: false,
			phoneSended: false,
			codeSending: false,
			codeSended: false,
			tfaSending: false,
			phoneMask: {
				mask: '+7 999 999 99 99',
				placeholder: ' ',
				showMaskOnHover: false,
			},
			codeMask: {
				mask: '9 9 9 9',
				placeholder: '•',
				showMaskOnHover: false,
			},
			tempToken: null,
		}
	},
	computed: {
		phoneValid() {
			return VLD.check(this.phone.replace(/\s+/g, ''), 'phoneRaw')
		},
		codeValid() {
			return VLD.check(this.code.replace(/\s+/g, ''), 'code4')
		},
	},
	methods: {
		sendPhone() {
			if (!this.phoneValid) return this.shake('phone-input')
			this.phoneSending = true
			this.phoneSended = true

			let data = { phone: this.phone.replace(/\s+/g, ''), uuid: 'admin' }

			this.$http.post(API.AUTH.phone, data).then(
				res => {
					if (res.data && !res.data.err) {
						this.tempToken = res.data.token
					}
				},
				err => {
					console.log(err)
				}
			)
		},
		async sendCode() {
			if (!this.tempToken) return
			this.codeSending = true

			let data = {
				code: this.code.replace(/\s+/g, ''),
				phone: this.phone.replace(/\s+/g, ''),
				token: this.tempToken,
				uuid: 'admin',
			}

			let res = await this.$http.post(API.AUTH.code, data)
			if (!res.data || res.data.err) {
				this.codeSending = false
				this.code = ''
				this.shake('code-input')
				return
			} else {
				if (res.data) {
					this.tempToken = res.data.token
				}

				this.codeSended = true
			}
		},
		async sendTfa() {
			if (this.tfa.length < 10) return
			if (this.tfaSending) return
			this.tfaSending = true

			let payload = {
				code: this.code.replace(/\s+/g, ''),
				phone: this.phone.replace(/\s+/g, ''),
				token: this.tempToken,
				tfa: this.tfa,
				uuid: 'admin',
			}

			let { data } = await this.$http.post(API.AUTH.tfa, payload)
			if (!data || data.err) return (this.tfaSending = false)

			this.$http.setToken(data.token, data.refresh)
			this.$store.commit('setUser', data)

			this.clearForm()
			this.tfaSending = false

			window.location.replace('/')
		},
		checkCode() {
			if (!this.codeValid) return
			this.codeSending = true
			this.sendCode()
		},
		shake(id) {
			let el = this.$el
			if (id) el = document.getElementById(id)
			let oldDisplay = el.style.display
			if (!el) {
				return
			}
			el.className = el.className.replace(/\bshake\b/, '')
			void el.offsetWidth
			el.className = el.className + ' shake'
		},
		clearForm() {
			this.phone = ''
			this.code = ''
			this.tfa = ''
			this.phoneSending = false
			this.phoneSended = false
			this.codeSending = false
			this.codeSended = false
			this.tempToken = null
		},
	},
}
</script>

<style lang="less" scoped>
// @import "../styles/fonts.less";

.form {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translateX(-50%) translateY(-50%);
}

.row {
	width: 300px;
	height: 60px;
}

.row {
	padding-bottom: 20px;
}

input {
	width: 100%;
	height: 100%;
	padding: 0 10%;
	// line-height: 60px;
	font-size: 20px;
	margin: 0 auto;
	display: block;
	border: none;
	outline: none;
	padding: 0;
	text-align: center;
	background: #fff;
	border-radius: 14px;
	box-sizing: border-box;
	transition: all 200ms ease;
	transition: all 300ms ease;
	opacity: 0;
	transform: translateY(20px);
	box-shadow: 0 20px 80px rgba(0, 0, 0, 0.1);
}

input.visible {
	opacity: 1;
	transform: translateY(0);
}

input:disabled {
	opacity: 0.5;
}

.confirm {
	width: 60px;
	height: 60px;
	position: absolute;
	top: 0;
	right: 0;
	text-align: center;
	line-height: 60px;
	color: #000;
	font-size: 26px;
	border-radius: 0 10px 10px 0;
	cursor: pointer;
}

.shake {
	animation: shake 500ms linear;
}

@keyframes shake {
	8%,
	41% {
		-webkit-transform: translateX(-10px);
	}
	25%,
	58% {
		-webkit-transform: translateX(10px);
	}
	75% {
		-webkit-transform: translateX(-5px);
	}
	92% {
		-webkit-transform: translateX(5px);
	}
	0%,
	100% {
		-webkit-transform: translateX(0);
	}
}
</style>
